import { render, staticRenderFns } from "./CreateGame.vue?vue&type=template&id=774d660e&scoped=true"
import script from "./CreateGame.vue?vue&type=script&lang=js"
export * from "./CreateGame.vue?vue&type=script&lang=js"
import style0 from "./CreateGame.vue?vue&type=style&index=0&id=774d660e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774d660e",
  null
  
)

export default component.exports